export default __webpack_public_path__ + "static/media/img-id-front.bc603290.svg";